import React from 'react';

import { DeviceTypes } from '../../../../utils/getDeviceType';
import {
  HeaderSignedInActionsDisplay,
  HeaderSignInSignUpActionsDisplay,
} from '../../Header.display';

type Props = {
  deviceType: DeviceTypes;
  isUserLoggedIn: boolean;
  onNavigateToApp: () => void;
  onClickSignIn: () => void;
  onClickSignUp: () => void;
  onClickDownload: () => void;
};

const HeaderActions = (props: Props) => {
  const { isUserLoggedIn, onClickSignUp, onNavigateToApp, onClickSignIn } = props;

  return isUserLoggedIn ? (
    <HeaderSignedInActionsDisplay onGoToWebApp={onNavigateToApp} />
  ) : (
    <HeaderSignInSignUpActionsDisplay onClickSignIn={onClickSignIn} onClickSignUp={onClickSignUp} />
  );
};

export default HeaderActions;
